
export default {
  'IDCLINE': 1
}
;






// WEBPACK FOOTER //
// ./src/lib/global.js